"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireWildcard(require("react"));

var _reactRedux = require("react-redux");

var _FormattedMessage = _interopRequireDefault(require("I18n/components/FormattedMessage"));

var _Hubs = require("self-service-api/constants/Hubs");

var _SeatsPicker = _interopRequireDefault(require("pricing-pages-unified-ui/components/common/SeatsPicker"));

var _ContactsPicker = _interopRequireDefault(require("pricing-pages-unified-ui/components/common/ContactsPicker"));

var _SuiteEditionMerchIdMap = _interopRequireDefault(require("pricing-pages-unified-ui/constants/SuiteEditionMerchIdMap"));

var _CalculatorDivider = _interopRequireDefault(require("pricing-pages-unified-ui/components/calculator/CalculatorDivider"));

var _H = _interopRequireDefault(require("UIComponents/elements/headings/H5"));

var _publicPageUrls = require("pricing-pages-unified-ui/utils/publicPageUrls");

var _CovidSelectors = require("../../selectors/CovidSelectors");

var _MarketingContactsSelectors = require("../../selectors/MarketingContactsSelectors");

var _ContactsSliderContainer = _interopRequireDefault(require("pricing-pages-unified-ui/components/common/ContactsSliderContainer"));

var SuiteAdditionalUnitsPicker = function SuiteAdditionalUnitsPicker(_ref) {
  var activeEdition = _ref.activeEdition,
      activeTerm = _ref.activeTerm,
      additionalUnitQuantities = _ref.additionalUnitQuantities,
      setAdditionalUnitQuantity = _ref.setAdditionalUnitQuantity;
  var isInMCBeta = (0, _reactRedux.useSelector)(_MarketingContactsSelectors.isInMCBetaSelector);
  var HubToMerchIdsMap = (0, _SuiteEditionMerchIdMap.default)(isInMCBeta)[activeEdition];
  var isCovidGrowthSuitePromoEligible = (0, _reactRedux.useSelector)(_CovidSelectors.isCovidGrowthSuitePromoEligibleSelector);
  return _react.default.createElement(_react.Fragment, null, isInMCBeta ? _react.default.createElement(_ContactsSliderContainer.default, {
    baseMerchId: HubToMerchIdsMap[_Hubs.HUB_MARKETING],
    onChange: function onChange(quantity) {
      return setAdditionalUnitQuantity({
        contacts: quantity
      });
    },
    additionalUnitQuantity: additionalUnitQuantities[_Hubs.HUB_MARKETING],
    term: activeTerm,
    isGrowthSuite: true,
    isCovidPromo: isCovidGrowthSuitePromoEligible
  }) : _react.default.createElement(_ContactsPicker.default, {
    moreDetailsGAClassName: (0, _publicPageUrls.getGAClassName)('growth-pricing-startercontacts'),
    className: "m-y-7",
    merchandiseId: HubToMerchIdsMap[_Hubs.HUB_MARKETING],
    additionalUnitQuantity: additionalUnitQuantities[_Hubs.HUB_MARKETING],
    onChange: function onChange(quantity) {
      return setAdditionalUnitQuantity({
        contacts: quantity
      });
    },
    term: activeTerm,
    isGrowthSuite: true,
    isCovidPromo: isCovidGrowthSuitePromoEligible
  }), _react.default.createElement(_CalculatorDivider.default, null), _react.default.createElement(_H.default, {
    className: "m-bottom-6"
  }, _react.default.createElement(_FormattedMessage.default, {
    message: "pricingPage.calculator.seats.title"
  })), _react.default.createElement("div", {
    className: "m-bottom-6"
  }, _react.default.createElement(_SeatsPicker.default, {
    merchandiseId: HubToMerchIdsMap[_Hubs.HUB_SALES],
    additionalUnitQuantity: additionalUnitQuantities[_Hubs.HUB_SALES],
    onChange: function onChange(quantity) {
      return setAdditionalUnitQuantity({
        sales_seats: quantity
      });
    },
    hideFreeUsersDisclaimer: true,
    useHubSpecificTitle: true,
    term: activeTerm,
    isGrowthSuite: true,
    isCovidPromo: isCovidGrowthSuitePromoEligible
  })), _react.default.createElement(_SeatsPicker.default, {
    merchandiseId: HubToMerchIdsMap[_Hubs.HUB_SERVICE],
    additionalUnitQuantity: additionalUnitQuantities[_Hubs.HUB_SERVICE],
    onChange: function onChange(quantity) {
      return setAdditionalUnitQuantity({
        service_seats: quantity
      });
    },
    hideFreeUsersDisclaimer: false,
    useHubSpecificTitle: true,
    term: activeTerm,
    isGrowthSuite: true,
    isCovidPromo: isCovidGrowthSuitePromoEligible
  }));
};

SuiteAdditionalUnitsPicker.propTypes = {
  activeEdition: _propTypes.default.string.isRequired,
  activeTerm: _propTypes.default.string.isRequired,
  additionalUnitQuantities: _propTypes.default.object.isRequired,
  setAdditionalUnitQuantity: _propTypes.default.func.isRequired
};
var _default = SuiteAdditionalUnitsPicker;
exports.default = _default;
module.exports = exports.default;


//////////////////
// WEBPACK FOOTER
// ./js/components/growth-suite-page/SuiteAdditionalUnitsPicker.js
// module id = 868
// module chunks = 5 6